import dayjs from "dayjs";

export function monthlyBalancesFromLedgers(ledgers, currency) {
  var maxValue = 100;
  var months = [];
  var creditBalances = [];
  var debitBalances = [];

  for (var i = 0; i < 12; i++) {
    const month = dayjs().add(-i, "months");
    months.push(month.format("MMM"));

    if (Array.isArray(ledgers)) {
      var results = ledgers
        .filter((ledger) => month.isSame(ledger.date, "month"))
        .filter((ledger) => ledger.currency === currency);

      const credit = results.reduce((sum, current) => {
        if (current.amount > 0) {
          return sum + current.amount;
        }
        return sum;
      }, 0);

      const debit = results.reduce((sum, current) => {
        if (current.amount < 0) {
          return sum + current.amount;
        }
        return sum;
      }, 0);

      if (credit > maxValue) {
        maxValue = credit;
      } else if (debit * -1 > maxValue) {
        maxValue = debit * -1;
      }
      creditBalances.push(credit);
      debitBalances.push(debit);
    } else {
      creditBalances.push(0);
      debitBalances.push(0);
    }
  }

  return {
    months: months.reverse(),
    creditBalances: creditBalances.reverse(),
    debitBalances: debitBalances.reverse(),
    maxValue: maxValue,
  };
}
